import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { getInvPartsByFilter, GetAllCategories } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { showInfoToast } from "../../components/ToastMesg";
import SelectFilter from "../../components/SelectFilter";
import DataGrid from "../../components/DataGrid";

const Inventory = () => {
  const navigate = useNavigate();
  const { storeG, companyG, userPermID } = useStateContext();
  const [getcategories, setCategories] = useState([]);
  const [AllInventory, setAllInventory] = useState("");
  const [category, setcategory] = useState("");
  const [Part, setPart] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const InventoryGrid = [
    {
      field: "category",
      headerText: "Category",
      minWidth: "140",
      width: "150",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "part_number",
      headerText: "Part No",
      minWidth: "125",
      width: "130",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "description",
      headerText: "Part Description",
      minWidth: "280",
      width: "360",
      maxWidth: "880",
      textAlign: "left",
    },
    {
      field: "total_stock",
      headerText: "Stk Qty",
      minWidth: "125",
      width: "135",
      maxWidth: "140",
      textAlign: "center",
    },
    {
      field: "low_stock",
      headerText: "Min Stk",
      minWidth: "125",
      width: "135",
      maxWidth: "140",
      textAlign: "center",
    },
    {
      field: "unit",
      headerText: "UoM",
      minWidth: "110",
      width: "120",
      maxWidth: "140",
      textAlign: "left",
    },
    {
      field: "s_category",
      headerText: "Sales Category",
      minWidth: "175",
      width: "180",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "stockroom_location",
      headerText: "Location",
      minWidth: "140",
      width: "180",
      maxWidth: "380",
      textAlign: "left",
    },
    {
      field: "cost_price",
      headerText: "Unit Price",
      minWidth: "140",
      width: "140",
      maxWidth: "180",
      format: "C2",
      textAlign: "right",
    },
    {
      field: "serialized_str",
      headerText: "Serialized",
      minWidth: "140",
      width: "140",
      maxWidth: "145",
      textAlign: "left",
    },
    {
      field: "pn_status",
      headerText: "Status",
      minWidth: "120",
      width: "120",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "bom_str",
      headerText: "BOM",
      minWidth: "110",
      width: "120",
      maxWidth: "120",
      textAlign: "left",
    },
    {
      field: "kit_open_count",
      headerText: "Kit Open",
      minWidth: "160",
      width: "160",
      maxWidth: "160",
      textAlign: "left",
    },
  ];

  const handleAddInvClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate("/Inventory/Add");
  };

  const handleInStockInvClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part && Part.part_id !== "")
      localStorage.setItem("copyPart", Part.part_id);
    navigate("/Inventory/InStock");
  };

  const handleOutStockInvClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part && Part.part_id !== "")
      localStorage.setItem("copyPart", Part.part_id);
    navigate("/Inventory/OutStock");
  };

  const handleTranferStkClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part && Part.part_id !== "")
      localStorage.setItem("copyPart", Part.part_id);
    navigate("/Inventory/TransferStock");
  };

  const handlePullKitClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Part && Part.part_id && Part.bom_str === "True")
      if (Part.last_kit_pending >= 500000)
        window.open(`/Kit/UpdateKit/${Part.last_kit_pending}`, "_blank");
      else window.open(`/Kit/PullKit/${Part.part_id}`, "_blank");
    else showInfoToast("Info!", "Please select BOM to pull new kit!");
  };

  const handleChangeCategory = (option) => {
    TimeoutUtility.resetTimeout();
    if (option && option.value) setcategory(option);
    else setcategory("select");
  };

  const handleRowSelected = (args) => setPart(args.data);

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        setloading(true);
        let cmp_id = null;
        let ctg_id = null;
        if (companyG !== null && companyG.company_id !== 0)
          cmp_id = companyG.company_id;
        if (category !== "select" && category !== "Select Term")
          ctg_id = category.value;
        trackPromise(
          getInvPartsByFilter(storeG.store_id, cmp_id, ctg_id)
            .then((productsResponse) => setAllInventory(productsResponse.data))
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [companyG, category, storeG]);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      let cmp_id = null;
      let ctg_id = null;
      if (companyG !== null && companyG.company_id !== 0)
        cmp_id = companyG.company_id;
      if (category !== "select" && category !== "Select Term")
        ctg_id = category.value;
      const resp = await getInvPartsByFilter(storeG.store_id, cmp_id, ctg_id);
      setAllInventory(resp.data || []);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      TimeoutUtility.resetTimeout();
      await GetAllCategories()
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.category_id,
          }));
          setCategories(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
    };
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Row>
        <Col xl={2} md={3}>
          <Header category="Stock" title="INVENTORY" />
        </Col>
        <Col xl={8} md={6} className="text-center">
          <Header title={companyG.name} />
        </Col>
      </Row>
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(48) && (
            <Col md="auto p-0">
              <Button text="Add Part to Inv" onClick={handleAddInvClick} />
            </Col>
          )}
          {userPermID.includes(49) && (
            <>
              <Col md="auto p-0">
                <Button text="In-Stock" onClick={handleInStockInvClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Out-Stock" onClick={handleOutStockInvClick} />
              </Col>
              <Col md="auto p-0">
                <Button text="Transfer Stock" onClick={handleTranferStkClick} />
              </Col>
            </>
          )}
          {userPermID.includes(34) && (
            <Col md="auto p-0">
              <Button text="Pull Kit" onClick={handlePullKitClick} />
            </Col>
          )}
          <Col md="auto p-0">
            <SelectFilter
              value={category}
              options={getcategories}
              onChange={handleChangeCategory}
              placeholder="Select Category"
            />
          </Col>
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllInventory}
        cols={InventoryGrid}
        handleRowSelected={handleRowSelected}
        persistant={false}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Inventory;
